import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class SPSCommerce_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public SPSCommerce: SPSCommerce_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

